import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { APIResponseModel } from '../models/api-response-model';

@Injectable({
  providedIn: 'root'
})

export class LendersService extends BaseService {

  constructor(http: HttpClient) {
    super(http, `lenders`);
  }

  uploadDocument(id: string, file: File): Observable<APIResponseModel<any>> {

    let formData = new FormData();
    formData.append(file.name, file);

    return this.http.post<APIResponseModel<any>>(`${this.baseUrl}/documentupload/${id}`, formData)
    .pipe(
        catchError((err: HttpErrorResponse) => {
           return this.httpErrorHandler(err, {});
        })
    );
  }

  getByOrganizationId(id: number, filters: any): Observable<APIResponseModel<any>> {
    return this.http.get<APIResponseModel<any>>(
      `${this.baseUrl}/organization/${id}`,
      filters ? { params: {...filters } } : { params: {} })
      .pipe(
          catchError((err: HttpErrorResponse) => {
            return this.httpErrorHandler(err, {});
          })
      );
  }


  changeUserAvailability(id: string, enabled: boolean): Observable<APIResponseModel<any>> {
    return this.http
      .post<APIResponseModel<any>>(`${this.baseUrl}/change-availability`, { id, enabled: enabled })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return this.httpErrorHandler(err, {});
        })
      );
  }
}
